import axios from 'axios'
import {baseUrl} from '../config'
import {ICandidate, IImageData, INewCandidate} from '../../types/candidate'
import {IQuestionsCategories} from '../../types/question'
import {IAnswer} from '../../types/answer'

export interface ILoginData {
  candidate?: INewCandidate
  dataString: string
}

interface UpdateCandidateResult {
  candidate: ICandidate
  questions: IQuestionsCategories[]
  answers: IAnswer[]
}

export function updateCandidate(electionId: number, candidate: Omit<ICandidate, 'election_id'>): Promise<UpdateCandidateResult> {
  const candidate_id = candidate.tunnus_id || candidate.id
  return axios
    .put(`${baseUrl}/${candidate_id}/election/${electionId}`, {
      ...candidate,
      constituency_id: null,
      party_id: null
    })
    .then(response => response.data)
}

export function uploadCandidatePhoto(candidate: ICandidate, imageData: IImageData): Promise<ICandidate> {
  const form = new FormData()
  const election_id = candidate.election_id
  const candidate_id = candidate.tunnus_id || candidate.id

  form.append('image', imageData.image)
  form.append('x', imageData.x.toString(10))
  form.append('y', imageData.y.toString(10))
  form.append('width', imageData.width!.toString(10))

  return axios.post(`${baseUrl}/${candidate_id}/election/${election_id}/photo`, form).then(response => response.data)
}

export async function adminGetCandidate(candidateId: number | string): Promise<ICandidate> {
  return axios.get(`${baseUrl}/admin/candidate/${candidateId}`).then(response => response.data)
}

export async function getCandidate(candidateId: string, electionId: string): Promise<ICandidate> {
  return axios.get(`${baseUrl}/${candidateId}/election/${electionId}`).then(response => response.data)
}

export async function createCandidate(candidateId: string, electionId: string, candidate: INewCandidate): Promise<ICandidate> {
  return axios.post(`${baseUrl}/${candidateId}/election/${electionId}`, candidate).then(response => response.data)
}
